import type { ButtonProps } from '@nuxt/ui'

const mobileFullWidthButton: NonNullable<ButtonProps['ui']> = {
  base: 'w-full flex justify-center md:w-auto md:inline-flex',
}

export { mobileFullWidthButton }
